
import { flowActionTypes } from '@constants/actionTypes/ssapActionTypes';
import { flowTypes as FLOW_TYPES } from '@constants/ssap/flows/flowTypes';

export const INITIAL_STATE = {
    flowType: FLOW_TYPES.NON_FINANCIAL_FLOW_NON_SWITCHABLE,
    isFlowLoaded: false
};

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case flowActionTypes.SET_FLOW:
            return {
                flowType: action.flowType,
                isFlowLoaded: true
            };
        case flowActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export const getSsapFlow = state => state.flowType;
export const getIfFlowLoaded = state => state.isFlowLoaded;